import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "field col-1"
}
const _hoisted_3 = { class: "flex align-content-center justify-content-center mt-3" }
const _hoisted_4 = { class: "field col-11" }

import { watch, ref, onMounted } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { EMIT, MEDICAID_FEATUREABLE_TYPE, PERMISSIONS } from '@/enum';
import { PersonStores, useRelayHubStore } from '@/store';
import { can } from '@/composables';
import { storeToRefs } from 'pinia';


export default /*@__PURE__*/_defineComponent({
  __name: 'MedicaidTable',
  emits: [EMIT.UPDATE],
  setup(__props, { emit: __emit }) {

const treatmentPlansStore = PersonStores.useUserTreatmentPlansStore();
const profileStore = PersonStores.useUserProfileStore();
const relayHubStore = useRelayHubStore();

const { userTreatmentPlans } = storeToRefs(treatmentPlansStore);
const { medicaidBilling } = storeToRefs(profileStore);

const diagnosis_code = ref(userTreatmentPlans.value?.diagnosis_code || '');
const medicaidEnabled = ref<boolean>(medicaidBilling?.value?.medicaid_enabled as boolean);

const emit = __emit;

watch(
  () => userTreatmentPlans.value,
  (value) => {
    diagnosis_code.value = value?.diagnosis_code || '';
  },
);

watch(
  () => medicaidBilling?.value,
  (value) => {
    medicaidEnabled.value = value?.medicaid_enabled;
  },
);

const rules = {
  diagnosis_code: { required },
};

const v$ = useVuelidate(rules, { diagnosis_code });

const resetDirty = () => v$.value.$reset();

const onSave = async () => {
  if (userTreatmentPlans.value && diagnosis_code.value !== userTreatmentPlans.value?.diagnosis_code) {
    userTreatmentPlans.value.diagnosis_code = diagnosis_code.value || '';
    await treatmentPlansStore.updateTreatmentPlan();
    treatmentPlansStore.doToast('Diagnosis Code has been added');
    emit(EMIT.UPDATE);
  }
  if (medicaidBilling?.value?.medicaid_enabled !== medicaidEnabled.value) {
    await toggleMedicaid();
    await getBillingInfo();
  }

  resetDirty();
};

const getBillingInfo = async () => {
  if (can([PERMISSIONS.MEDICAID_MANAGE_CLINICIANS])) {
    await profileStore.getMedicaidBilling();
    if (profileStore.error) profileStore.doToast(profileStore.error as string, 'Error', true);
  }
};

const onCancel = () => {
  diagnosis_code.value = userTreatmentPlans.value?.diagnosis_code || '';
  resetDirty();
};

const toggleMedicaid = async () => {
  const personId: number = userTreatmentPlans.value?.person_id as number;

  if (medicaidEnabled.value) {
    await relayHubStore.enableMedicaid([personId], MEDICAID_FEATUREABLE_TYPE.PEOPLE);
    if (!relayHubStore.error) relayHubStore.doToast(`Student is now Medicaid Enabled.`);
    else relayHubStore.doToast(relayHubStore.message as string, 'Error', true);
  } else {
    await relayHubStore.disableMedicaid([personId], MEDICAID_FEATUREABLE_TYPE.PEOPLE);
    if (!relayHubStore.error) relayHubStore.doToast(`Student is now Medicaid Disabled.`);
    else relayHubStore.doToast(relayHubStore.message as string, 'Error', true);
  }
};

onMounted(async () => await getBillingInfo());

return (_ctx: any,_cache: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FormCard = _resolveComponent("FormCard")!

  return (_openBlock(), _createBlock(_component_FormCard, {
    title: "Medicaid",
    cancel: onCancel,
    save: onSave,
    dirty: _unref(v$).$anyDirty
  }, {
    form: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        (_unref(can)([_unref(PERMISSIONS).MEDICAID_MANAGE_CLINICIANS]))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[2] || (_cache[2] = _createElementVNode("label", {
                for: "enable",
                class: "block mb-2 text-center"
              }, "Enable", -1)),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Checkbox, {
                  id: "enable",
                  modelValue: medicaidEnabled.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((medicaidEnabled).value = $event)),
                  size: "large",
                  binary: true,
                  disabled: !_unref(can)([_unref(PERMISSIONS).MEDICAID_MANAGE_CLINICIANS]),
                  onChange: _unref(v$).$touch
                }, null, 8, ["modelValue", "disabled", "onChange"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("label", {
            for: "code",
            class: "block mb-2"
          }, "Diagnosis Code", -1)),
          _createVNode(_component_InputText, {
            id: "code",
            modelValue: _unref(v$).diagnosis_code.$model,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).diagnosis_code.$model) = $event)),
            disabled: !_unref(can)([_unref(PERMISSIONS).PERSON_TREATMENT_PLANS_STORE]),
            type: "url",
            class: _normalizeClass(["inputfield w-full", { 'p-invalid': _unref(v$).diagnosis_code.$dirty }])
          }, null, 8, ["modelValue", "disabled", "class"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["dirty"]))
}
}

})